import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserStore } from '../services/current-user-store';

/**
 * Route guard: pass only for statewide operators (Admin with no tenant binding).
 * Defense-in-depth alongside server-side checks — the API must also enforce this.
 */
export const statewideGuard: CanActivateFn = async () => {
  const store = inject(CurrentUserStore);
  const router = inject(Router);

  if (store.me() === null) {
    await store.load();
  }

  if (store.isStatewide()) return true;
  return router.createUrlTree(['/dashboard']);
};
